import { render, staticRenderFns } from "./r-item-boost-rule-table.vue?vue&type=template&id=a8e8100e"
import script from "./r-item-boost-rule-table.vue?vue&type=script&lang=js"
export * from "./r-item-boost-rule-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a8e8100e')) {
      api.createRecord('a8e8100e', component.options)
    } else {
      api.reload('a8e8100e', component.options)
    }
    module.hot.accept("./r-item-boost-rule-table.vue?vue&type=template&id=a8e8100e", function () {
      api.rerender('a8e8100e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/item/boost/r-item-boost-rule-table.vue"
export default component.exports